import React from 'react';

const SvgIconDatepicker = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 15 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.702 1.225H11.31V.661a.66.66 0 10-1.322 0v.564H4.7V.661a.66.66 0 10-1.321 0v.564H1.983C.889 1.225 0 2.115 0 3.208v10.556c0 1.093.89 1.982 1.983 1.982h10.72c1.094 0 1.984-.889 1.984-1.982V3.208a1.988 1.988 0 00-1.985-1.983zM1.982 2.547H3.38v.84a.66.66 0 101.321 0v-.84h5.288v.84a.66.66 0 101.322 0v-.84h1.392c.364 0 .66.297.66.661v1.549H1.323V3.208c0-.364.295-.66.66-.66zm10.72 11.878H1.982a.662.662 0 01-.66-.661V6.08h12.043v7.685a.664.664 0 01-.663.66zm-1.577-6.79H3.192a.66.66 0 100 1.323h7.933a.66.66 0 100-1.322zm0 3.202H3.192a.66.66 0 100 1.322h7.933a.66.66 0 100-1.322z" />
  </svg>
);

export default SvgIconDatepicker;
